<template>
  <NuxtLayout>
    <AccommodationsListing :page="page" />
  </NuxtLayout>
</template>

<script setup lang="ts">
  defineProps({
    page: {
      type: Object
    }
  });
  
  useHead({
    htmlAttrs: {
      class: 'fixedHeader',
    },
  });
</script>